import {
    emptyOrdersQueryResponse,
    emptyGetOrderByIdQueryResponseMock,
    adyenCheckoutSessionQueryResponseMock,
    adyenSetupQueryResponseMock,
    adyenBinLookupResponseMock,
    applyCarpayVoucherErrorResponseMock,
    carpayLotsQueryResponseMock,
    carpayLotByIdQueryResponseMock,
    gerErrorFlowPriceQueryResponseMock
} from './mockData'
import { GraphQLHandlerData, RestHandlerData } from './types'

type HandlersContext = {
    rawHandlerDataGraphql: GraphQLHandlerData[]
    rawHandlerDataRest: RestHandlerData[]
}

// Here you define all your "endpoints" (since we are using graphql we define all our queries)
// This queries will be intercepted in order to not reach the server (if this is what we want)
// When we make a query named mockQuery we are gonna get back mockQuery result (mocked)
const buildHandlersContext = (): HandlersContext => {
    const rawHandlerDataGraphql: GraphQLHandlerData[] = [
        {
            type: 'QUERY',
            name: 'B2CGetOpenOrders',
            data: emptyOrdersQueryResponse
        },
        {
            type: 'QUERY',
            name: 'B2CGetOrderById',
            data: emptyGetOrderByIdQueryResponseMock
        },
        {
            type: 'QUERY',
            name: 'B2CGetCheckoutSession',
            data: adyenCheckoutSessionQueryResponseMock
        },
        {
            type: 'QUERY',
            name: 'B2CGetErrorFlowCheckoutSession',
            data: adyenCheckoutSessionQueryResponseMock
        },
        {
            type: 'QUERY',
            name: 'b2c_get_carpay_lots',
            data: carpayLotsQueryResponseMock
        },
        {
            type: 'QUERY',
            name: 'B2CGetLotById',
            data: carpayLotByIdQueryResponseMock
        },
        {
            type: 'MUTATION',
            name: 'B2CApplyCarpayVoucher',
            data: applyCarpayVoucherErrorResponseMock
        },
        {
            type: 'QUERY',
            name: 'GetErrorflowPrice',
            data: gerErrorFlowPriceQueryResponseMock
        }
    ]

    const rawHandlerDataRest: RestHandlerData[] = [
        {
            method: 'POST',
            url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/v1/sessions/*/setup',
            response: adyenSetupQueryResponseMock
        },
        {
            method: 'POST',
            url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/v1/sessions/*/payments',
            response: {}
        },
        {
            method: 'POST',
            url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/v3/bin/binLookup',
            response: adyenBinLookupResponseMock
        },
        {
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/js',
            response: {
                status: 200,
                body: '/* Google Maps API mock */',
                headers: {
                    'Content-Type': 'application/javascript'
                }
            }
        }
        // { method: 'GET', url: 'https://hasura.stage.park-depot.de/v1/graphql', response: { status: 200 } }
    ]

    return {
        rawHandlerDataGraphql,
        rawHandlerDataRest
    }
}

export default buildHandlersContext
